import React, { ReactElement } from 'react';
import Table from 'react-bootstrap/Table';
import { Client } from '../../../../../common/src/entities';

type DynamicTableParametreReservationProps = {
    data: Client;
    title: string;
};

export default function DynamicTableParametreReservation({
    data,
    title,
}: DynamicTableParametreReservationProps): ReactElement {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th># moyen pédago</th>
                        <th># moyen sortie</th>
                        <th># SDG total</th>
                        <th># élève total</th>
                        <th># de groupe-classe</th>
                    </tr>
                </thead>
                <tbody>
                    <td>{data.nb_avg_pedago} </td>
                    <td>{data.nb_avg_sortie}</td>
                    <td>{data.nb_sdg_total}</td>
                    <td>{data.nb_eleves_total}</td>
                    <td>{data.nb_groupe_classe}</td>
                </tbody>
            </Table>
        </div>
    );
}
